import React from 'react';

import { Flex } from 'antd';
import DashboardTemplate from 'src/templates/DashboardTemplate';
import {
	CardContainer,
	LayoutContainer,
	TopBigWidgetContainer,
	TopSmallWidgetContainer,
	BottomBigWidgetContainer,
	BottomSmallWidgetContainer
} from 'src/pages/dashboard/styles';
import {
	TotalOccurrences,
	OccurrencesTable,
	OccurrencesByPeriod,
	OccurrencesTimeline,
	OccurrencesBySeverity,
	DayWithMostOccurrences,
	SeverityWithMostOccurrences,
	PeriodDisplay,
	TotalOpenedOccurrences
} from 'src/pages/dashboard/components';
import {
	Context
} from 'src/pages/dashboard/contexts/useOccurrences';
import { useOccurrences as __useOccurrences } from 'src/hooks/useOccurrences';

export default function Dashboard() {
	const useOccurrences = __useOccurrences();

	return(
		<DashboardTemplate>
			<Context.Provider value={{ useOccurrences, }} >
				<LayoutContainer>
					<Flex gap={16} wrap='wrap' justify='space-between'>
						<CardContainer>
							<PeriodDisplay />
						</CardContainer>
						<CardContainer>
							<TotalOccurrences />
						</CardContainer>
						<CardContainer>
							<TotalOpenedOccurrences />
						</CardContainer>
						<CardContainer>
							<SeverityWithMostOccurrences />
						</CardContainer>
						<CardContainer>
							<DayWithMostOccurrences />
						</CardContainer>
					</Flex>
					<Flex gap={24} wrap='wrap'>
						<TopSmallWidgetContainer>
							<OccurrencesBySeverity />
						</TopSmallWidgetContainer>
						<TopBigWidgetContainer>
							<OccurrencesByPeriod />
						</TopBigWidgetContainer>
					</Flex>
					<Flex gap={24} wrap='wrap'>
						<BottomBigWidgetContainer>
							<OccurrencesTable />
						</BottomBigWidgetContainer>
						<BottomSmallWidgetContainer>
							<OccurrencesTimeline />
						</BottomSmallWidgetContainer>
					</Flex>
				</LayoutContainer>
			</Context.Provider>
		</DashboardTemplate>
	);
}
